var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mx-auto"},[_c('div',{staticClass:"mt-7 bg-white rounded-md"},[_c('h1',{staticClass:"[ font-bold text-2xl ] [ pt-7 pb-5 px-10 ] [ border-b border-gray-200 ]"},[_vm._v("الإعدادات")]),_c('Branches')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }